<template>
  <div>
    <div class="d-flex align-items-center mr-5 pb-2 pb-md-0">
      <h4 class="font-weight-bold mb-0 tituloPagina">
        PROMOÇÕES RECOMENDADAS
      </h4>
    </div>
    <div class="lista-de-caixas">
      <div v-for="item in promocoesSemelhantes" :key="item.id">
        <box :box="item"></box>
      </div>
    </div>
  </div>
</template>
<script>
import box from './box.vue';
export default {
  props: ['promocoesSemelhantes'],
  components: {
    box,
  },
  methods: {},
};
</script>
